import React from "react";
import { DialogMessage } from "@tvg/design-system";
import { useSelector } from "react-redux";
import { Props } from "./types";
import { Container } from "./styled-components";
import { getPopularRacesNoRacesContent } from "../../redux/selectors";

export const NoRacesAvailable = ({ qaLabel }: Props) => {
  const { title, description } = useSelector(getPopularRacesNoRacesContent);

  return (
    <Container data-qa-label={qaLabel}>
      <DialogMessage title={title} description={description} variant="info" />
    </Container>
  );
};
